import { defineComponent as o, h as d } from "vue";
const m = o({
  name: "TimePickerPanelCol",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    activeValue: {
      type: Number,
      default: null
    },
    // It should be required but vue's type seems to have bugs
    onItemClick: Function
  },
  render() {
    const {
      activeValue: c,
      onItemClick: t,
      clsPrefix: e
    } = this;
    return this.data.map((n) => {
      const {
        label: i,
        disabled: a,
        value: l
      } = n, r = c === l;
      return d("div", {
        key: i,
        "data-active": r ? "" : null,
        class: [`${e}-time-picker-col__item`, r && `${e}-time-picker-col__item--active`, a && `${e}-time-picker-col__item--disabled`],
        onClick: t && !a ? () => {
          t(l);
        } : void 0
      }, i);
    });
  }
});
export {
  m as default
};
